module.exports = __webpack_public_path__ + "img/001-098.91804fa0.png";